import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {FormGroupDirective} from '@angular/forms';
import {Subscription} from 'rxjs';

@Component({
  selector: 'app-form-error',
  templateUrl: './form-error.component.html',
  styleUrls: ['./form-error.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class FormErrorComponent implements OnInit, OnDestroy {
  private subscription: Subscription;

  constructor(private formGroupDirective: FormGroupDirective,
              private cdr: ChangeDetectorRef) {
  }

  get errors(): string[] | null {
    const form = this.formGroupDirective.form;
    if (!form || !form.invalid) return null;

    return this.validation(form.getError('errors'))
      || (form.getError('detail') ? [form.getError('detail')] : null)
      || (form.getError('status') == 403 ? ['You don\'t have permission to access this page'] : null)
      || (form.getError('title') ? [form.getError('title')] : null)
      || (form.hasError('status') ? ['An unexpected server error occurred'] : null);
  }

  private validation(errors: unknown): string[] | null {
    const values = Array.isArray(errors)
      ? errors.map(error => typeof error === 'string' ? error : error?.value)
      : errors && typeof errors === 'object'
        ? Object.values(errors).flat()
        : [];
    const messages = values.filter((value): value is string =>
      typeof value === 'string' && value.trim().length > 0);

    return messages.length ? messages : null;
  }

  ngOnInit(): void {
    this.subscription = this.formGroupDirective.form.statusChanges
      .subscribe(() => this.cdr.markForCheck());
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
